import JobTrackingView from './JobTrackingView'
export default JobTrackingView
